import React, { useEffect } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useSocket } from "../Components/SocketContext";
import useSocketHandlers from "../Components/useSocketHandlers";
import { SOCKET_EVENT_TYPE } from "../../helpers/common";
import { useSelector } from "react-redux";

const ContinueAfterFinishAnswer = () => {
  const navigate = useNavigate();
  const { socket } = useSocket();
  const { t } = useTranslation();
  const userPoints = useSelector((state) => state?.session?.points) || 0;
  const userName =
    useSelector((state) => state?.session?.sessionData?.receiver?.name) || "";
  const lastSummaryRating =
    useSelector((state) => state?.session?.lastSummaryRating) || null;

  const {
    handleQuestionAsked,
    handleQuestionMake,
    handleCancelSessionResponseForSender,
    handlerCancelSessionResponseForReceiver,
    handleSubmitAnswerResForReceiver,
    handleSocketErr,
    stopSession,
  } = useSocketHandlers();

  useEffect(() => {
    if (socket) {
      socket.on(SOCKET_EVENT_TYPE.QUESTION_ASKED, handleQuestionAsked);
      socket.on(SOCKET_EVENT_TYPE.STATEMENT_ASKED, handleQuestionMake);
      socket.on(
        SOCKET_EVENT_TYPE.STATEMENT_SUMMARIZED_RESPONSE_RECEIVER,
        handleSubmitAnswerResForReceiver,
      );
      socket.on(
        SOCKET_EVENT_TYPE.CLOSE_SESSION_SENDER_RESPONSE,
        handleCancelSessionResponseForSender,
      );
      socket.on(
        SOCKET_EVENT_TYPE.CLOSE_SESSION_RECEIVER_RESPONSE,
        handlerCancelSessionResponseForReceiver,
      );
      socket.on(SOCKET_EVENT_TYPE.ERROR, handleSocketErr);
      return () => {
        socket.off(SOCKET_EVENT_TYPE.QUESTION_ASKED, handleQuestionAsked);
        socket.off(SOCKET_EVENT_TYPE.STATEMENT_ASKED, handleQuestionMake);
        socket.off(
          SOCKET_EVENT_TYPE.STATEMENT_SUMMARIZED_RESPONSE_RECEIVER,
          handleSubmitAnswerResForReceiver,
        );
        socket.off(
          SOCKET_EVENT_TYPE.CLOSE_SESSION_SENDER_RESPONSE,
          handleCancelSessionResponseForSender,
        );
        socket.off(
          SOCKET_EVENT_TYPE.CLOSE_SESSION_RECEIVER_RESPONSE,
          handlerCancelSessionResponseForReceiver,
        );
        socket.off(SOCKET_EVENT_TYPE.ERROR, handleSocketErr);
      };
    }
  }, [
    socket,
    navigate,
    handleSubmitAnswerResForReceiver,
    handleQuestionAsked,
    handleQuestionMake,
    handleCancelSessionResponseForSender,
    handlerCancelSessionResponseForReceiver,
    handleSocketErr,
  ]);

  const ratingText =
    lastSummaryRating === 1
      ? "summaryRatingPerfect"
      : lastSummaryRating === 2
        ? "summaryRatingGood"
        : "summaryRatingBad";

  console.log("lastSummaryRating", lastSummaryRating, ratingText);

  return (
    <div className="content-box contact">
      <div className="main_content">
        <div className="innerContent">
          <div className="listenBtn">
            <button className="waved_btn">
              <Trans
                i18nKey={lastSummaryRating ? ratingText : "listenAfterContinue"}
                values={{ name: userName }}
                components={{ 1: <br></br> }}
              />
            </button>
          </div>
        </div>
      </div>
      <div className="bottomNav">
        <div className="points">
          {t("points")}: {userPoints}
        </div>
        <div onClick={stopSession} className="stop">
          Stop
          <img alt="" src="assets/image/cross.png" />
        </div>
      </div>
    </div>
  );
};

export default ContinueAfterFinishAnswer;
